import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

/**
 * Create request is handled by the modal on My Requests index.
 * Redirect to index so the user can click "Create Request" to open the modal.
 */
export default function MyRequestCreatePage() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/my-request', { replace: true })
  }, [navigate])
  return null
}
